import BaseProxy from './Proxy';

export default class SubstoreProductDetailsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/details', parameters);
  }

  partner(partnerName) {
    return this.submit('get', `${this.endpoint}/partner/${partnerName}`);
  }

  partnerAction(params) {
    return this.submit('post', `${this.endpoint}/partner/action`, params);
  }
}
